import { BsPeopleFill } from "react-icons/bs";
import { CgSandClock } from "react-icons/cg";
import { FaChair } from "react-icons/fa";
import { MdOutlineLunchDining } from "react-icons/md";
import { PiBookOpenDuotone, PiNotepadDuotone } from "react-icons/pi";

export const NavItems=[
   
    {
        to:"makeorder",
        name:"CreateOrder",
        icon:<FaChair/>

    },{
        to:"menus",
        name:"Items",
        icon:<MdOutlineLunchDining/>
    },{
        to:"staff",
        name:"People",
        icon:<BsPeopleFill/>
    },{
        to:"sales",
        name:"Sales",
        icon:<PiBookOpenDuotone/>
    },{
        to:"orders",
        name:"Order",
        icon:<CgSandClock/>
    },
    {
        to:"order-status",
        name:"Status",
        icon:<PiNotepadDuotone/>
    }
]